export const blueberry = '#34454e'
export const white = '#ffffff'
